import { toast } from "react-toastify";
import Layout from "../../../components/Layout";
import { useMediaQuery } from "@mui/material";
import { httprequest } from "../../../data/api";
import { useEffect, useState } from "react";
import Table from "../../../components/Table/Table";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import BreadCrumb from "../../../components/BreadCrumb";
import { Icon } from "@iconify/react/dist/iconify.js";
import Button from "../../../components/Button";
import { useParams } from "react-router-dom";
import PageLoader from "../../../components/PageLoader";

const CLASSES_ENDPOINT = "/api/v1/class";
const GET_SESSIONS = "/api/v1/school-plan/session";
const REPORT_ENDPOINT = "/api/v1/session-report/class";

const ViewSessionClass = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [classesData, setClassData] = useState([]);
  const [activeSession, setActiveSession] = useState([]);
  const [allSessions, setAllSessions] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const { id } = useParams();
  const [reportData, setReportData] = useState([]);
  const [isReportLoading, setIsReportLoading] = useState(false);

  const getAllClasses = () => {
    httprequest
      .get(CLASSES_ENDPOINT)
      .then((res) => {
        const physicalClasses = res?.data?.data?.filter(
          (data) => data?.class_type === "physical"
        );
        setClassData(physicalClasses);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  const handleSessionChange = (e) => {
    const sessionId = e.target.value;
    const selectedSession = allSessions.find(sesh => String(sesh.id) === String(sessionId));
    setActiveSession(selectedSession);
    // getSessionReport(sessionId, selectedClass);
  };

  const handleClassChange = (e) => {
    const classId = e.target.value;
    setSelectedClass(classId);
    // if (activeSession?.id) {
    //   getSessionReport(activeSession.id, classId);
    // }
  };

  const getAllReport = async () => {
    setIsReportLoading(true);
    try {
      const res = await httprequest.get(`${REPORT_ENDPOINT}/${id}`);
      setReportData(res.data.data);
    } catch (err) {
      toast.error(err.response?.message || "Failed to fetch reports");
    } finally {
      setIsReportLoading(false);
    }
  };

  const columns = [
    {
      name: "Student Name",
      selector: row => (
        <>
          {isMobile && <p className="mobile-styling">Student Name</p>}
          {row.name}
        </>
      ),
      sortable: true
    },
    {
      name: "Term 1",
      selector: row => (
        <>
          {isMobile && <p className="mobile-styling">Term 1</p>}
          {row.term1}
        </>
      ),
      sortable: true
    },
    {
      name: "Term 2",
      selector: row => (
        <>
          {isMobile && <p className="mobile-styling">Term 2</p>}
          {row.term2}
        </>
      ),
      sortable: true
    },
    {
      name: "Term 3",
      selector: row => (
        <>
          {isMobile && <p className="mobile-styling">Term 3</p>}
          {row.term3}
        </>
      ),
      sortable: true
    },
    {
      name: "Session Avg",
      selector: row => (
        <>
          {isMobile && <p className="mobile-styling">Session Avg</p>}
          {row.sessionAvg}
        </>
      ),
      sortable: true
    },
    {
      name: "Grade",
      selector: row => (
        <>
          {isMobile && <p className="mobile-styling">Grade</p>}
          <span className={`grade-badge grade-${row.grade}`}>
            {row.grade}
          </span>
        </>
      ),
      sortable: true
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon">
            <Icon icon="hugeicons:view" />
          </button>
        </div>
      )
    }
  ];

  useEffect(() => {
    getAllClasses();
    getAllSessions();
    getAllReport();
  }, []);

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb
              link_one="/report/reports"
              link_one_name="Reports"
              link_two_name="Session Report"
              link_two="/report/session"
              active="Session Report"
              description="See all the result in the Session"
            />
          </div>
          <div className="flex gap-10">
            <div>
              {allSessions && allSessions.length > 0 && (
                <SelectGroup
                  children={
                    <select
                      value={activeSession?.id || ""}
                      onChange={handleSessionChange}
                      name="session"
                    >
                      <option value="">---Select---</option>
                      {allSessions?.map((sesh) => {
                        return (
                          <option key={sesh?.id} value={sesh?.id}>
                            {sesh?.session}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
              )}
            </div>
            <div>
              <SelectGroup
                children={
                  <select onChange={handleClassChange} name="term" value={selectedClass}>
                    <option value="">--All Class--</option>
                    {classesData?.map((data) => {
                      return (
                        <option key={data?.id} value={data?.id}>
                          {data?.class_name}
                        </option>
                      );
                    })}
                  </select>
                }
              />
            </div>
          </div>
        </div>

        <div className="page-content margin-top-30">
          {isReportLoading ?
            <PageLoader />
            :
            <>
              <Table
                data={reportData}
                columns={columns}
                subHeader={false}
                pagination
              />

              <div className="flex gap-10 margin-top-30">
                <Button
                  variant="primaryoutline"
                  buttonSize="fluid"
                  color="btnfontprimary"
                  buttonName="Check Promotion Status"
                />
                <Button
                  variant="primary"
                  buttonSize="medium"
                  color="btndefault"
                  buttonName="Download Result"
                />
              </div>
            </>}
        </div>
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default ViewSessionClass;
